// extracted by mini-css-extract-plugin
export default {"tabContain":"style_tabContain__inWEJ","tabs":"style_tabs__ID4xY","active":"style_active__96Dnf","formContent":"style_formContent__KTJQj"};